var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TablePaginated',{attrs:{"label":_vm.activeRouteFilterName,"main-list":_vm.itemData,"is-global-percent":_vm.isGlobalPercent,"is-active":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }